<div class="app-single-agent mb-1" *ngFor="let violation of violationList">
    <div class="card rounded-pill bg-white-80" [ngClass]="violation.isSelected? 'bgselectedAgent': ''">
        <div class="col-12 px-2 py-1 d-flex flex-row" (click)="selectViolation(violation)">
            <div class="col-2 align-self-center position-relative ">
                <img src={{violation.AgentProfilePic}} alt="" class="rounded-circle w-100 b-color" loading="lazy"
                    id="superadmin_img_{{violation.ViolationId}}" (error)="onProfilePictureErrorEvent($event)">
                <i class="fas fa-user agent-img-default" style="display: none;"
                    id="superadmin_img_default_{{violation.ViolationId}}"></i>
            </div>
            <div class="col-6 text-warning ps-2 me-1 pt-2 ">
                <h6 class="card-text text-truncate font-md m-0 font-primary-color fw-bolder" data-bs-toggle="tooltip"
                    data-bs-placement="top" title="{{violation.FullName}}">
                    {{ violation.AgentFirstName + " " + violation.AgentLastName}}
                </h6>
                <p class="card-text text-truncate font-sm m-0 font-primary-color fw-600" data-bs-toggle="tooltip"
                    data-bs-placement="top" title={{violation.ViolationName}}>{{violation.ViolationName}}</p>
                <p class="card-text text-truncate font-xs m-0 font-primary-color" data-bs-toggle="tooltip"
                    data-bs-placement="top">{{violation.FormattedSentDateTime |
                    date:'medium'}}</p>
            </div>
            <div class=" col-4 d-flex align-items-end ps-2">
                <div class="d-flex w-100">

                    <div class="w-100 float-end">

                        <p class="card-text text-truncate font-xs m-0 font-primary-color">Sent by:</p>

                        <p class="card-text text-truncate font-xs m-0 font-primary-color col-6 sentbywidth "
                            data-bs-toggle="tooltip" data-bs-placement="top" title={{violation.SentBy}}>
                            {{violation.SentBy}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>